import React from 'react';
import type DeploymentFrequencyReportSpa from '@jira/spa-apps__deployment-frequency-report/src/DeploymentFrequencyReportSpa.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/** @deprecated remove when clean up entrypoint-reports-deployment-frequency-classic */
export const LazyDeploymentFrequencyReport: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof DeploymentFrequencyReportSpa
>(
	() =>
		import(
			/* webpackChunkName: "async-deployment-frequency-report", jiraSpaEntry: "async-deployment-frequency-report" */ '@jira/spa-apps__deployment-frequency-report/src/DeploymentFrequencyReport.tsx'
		),
);

export const DeploymentFrequencyReportNextGen = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDeploymentFrequencyReport}
		pageId="deploymentFrequencyReportNextGen"
		shouldShowSpinner
	/>
);

export const DeploymentFrequencyReportClassic = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDeploymentFrequencyReport}
		pageId="deploymentFrequencyReportClassic"
		shouldShowSpinner
	/>
);
